export default "__VITE_ASSET__C$u0LdYN__"